import { createAsyncThunk } from '@reduxjs/toolkit';
import { Notification } from '../../../clubhouse/models/notification';

export const addToMessageList = createAsyncThunk(
    'supportMessages/add',
    (notification: Notification) => {
        return {
            message: notification.message,
            threadId: notification.chatId,
        };
    }
);
